import StrategyCycle from "../../Assets/Images/Ökobilanz_Wertgrafik_cycle.jpg";
import StrategyLinear from "../../Assets/Images/Ökobilanz_Wertgrafik_linear.jpg";
import "./StrategyPage.style.css";

import CycleStrategyMap from "../../Components/CycleStrategyMap/CycleStrategyMap";
import Data from "../../Assets/Content/StrategyData.js";
import { useEffect } from "react";
import ExpandableCard from "../../Components/ExpandableCard/ExpandableCard";
import EconomySwitch from "../../Components/EconomySwitch/EconomySwitch";

const StrategyPage = (props) => {
  const { content, setContent, economyType } = props.AppStateService;
  const { circularEconomyState, onChangeEconomySwitch } = props;

  const isLinear = economyType === "linear";

  useEffect(() => {
    document.title = "Kreislaufwirtschaftsguide | Strategy";
  }, []);

  let setFixText = () => {
    if (economyType === "linear") {
      setContent(Data.LinearMain);
    } else {
      setContent(Data.CycleMain);
    }
  };

  let getMapContent = (economyType) => {
    if (economyType === "linear") {
      return (
        <>
          <img
            src={StrategyLinear}
            alt=""
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
            onClick={() => {
              let fixText =
                economyType === "linear" ? Data.LinearMain : Data.CycleMain;
              setContent(fixText);
            }}
          />
        </>
      );
    } else {
      return (
        <>
          <img
            src={StrategyCycle}
            alt=""
            useMap="#image-map-full"
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
            onClick={() => {
              let fixText =
                economyType === "linear" ? Data.LinearMain : Data.CycleMain;
              setContent(fixText);
            }}
          />
          <CycleStrategyMap
            AppStateService={{
              setContent,
              economyType,
              setFixText,
            }}
          />
        </>
      );
    }
  };

  return (
    <div className="container-fluid mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <ExpandableCard title="Strategien" initiallyOpen={true}>
            <div className="sticky-switch-container">
              <EconomySwitch
                onChangeEconomySwitch={onChangeEconomySwitch}
                circularEconomyState={circularEconomyState}
              />
            </div>
            <div className="hover-text mb-3">
              Wechseln Sie zwischen der Ansicht „Kreislaufwirtschaft“ und
              „Linearwirtschaft“ mithilfe des Buttons oben.
              <br />
              Fahren Sie mit der Maus über die Elemente der Grafik, um mehr zu
              erfahren.
            </div>

            <div className="row align-items-start">
              <div className="col-lg-8" id="strategy-map-container">
                {getMapContent(economyType)}
              </div>

              <div className="col-lg-4 strategy-text-container mt-3 mt-lg-0">
                <div className="heading">
                  {isLinear
                    ? Data.LinearMain.heading
                    : content?.heading || Data.CycleMain.heading}
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: (isLinear
                      ? Data.LinearMain.text
                      : content?.text || Data.CycleMain.text
                    )?.replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            </div>
          </ExpandableCard>
        </div>
      </div>
    </div>
  );
};

export default StrategyPage;
